import api from './index';

interface PostLiveClassFeedbackData {
  live_class_id: number | undefined;
  survey_result: 'happy' | 'sad';
}
export const postLiveClassFeedback = (props: PostLiveClassFeedbackData) => {
  return api.post(`/v4/feedback/liveclass`, props);
};
